<script setup lang="ts">
  import type { PropType } from 'vue';
  import type { Photo } from '@storefront/resources';

  interface Item {
    photos: Photo[],
    link: string,
    ariaLabel: string,
  }

  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    items: { type: Array as PropType<Item[]>, required: true, default: [] },
  });
</script>
<template>
  <section v-if="items.length > 0" class="banner-two-block">
    <div v-for="item in items">
      <a v-if="item.link" :href="item.link" :aria-label="item.ariaLabel">
        <MediaPicture :photo="item.photos[0]" type="background" sizes="1984x662 2x max 992, 992x331 max 992, 1384x462 2x, 692x231" />
      </a>
      <MediaPicture v-else :photo="item.photos[0]" type="background" sizes="1984x662 2x max 992, 992x331 max 992, 1384x462 2x, 692x231" />
    </div>
  </section>
</template>
<style scoped lang="scss">
  @use '@storefront/styles/mixins/media' as media;

  .banner-two-block {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;

    :deep(picture) {
      width: 100%;

      img {
        object-fit: cover;
        aspect-ratio: 3/1;
        width: 100%;
        border-radius: var(--border-radius);

        @include media.query(lg) {
          border-radius: 0;
        }
      }
    }

    @include media.query(lg) {
      grid-template-columns: 1fr;
    }
  }
</style>
